import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { Case, CoverageRequestRating, CoverageRequestTherapyDecision } from "../models/generated/graphql";
import { neo4jDateToDate } from "./neo4j-date-to-date";
import { deserialize } from "./serialization";

export const getCoverageBoundaries = (caseInstance: Case) => {
	return caseInstance.flexEntities
		.map((entity) => {
			const negotiationRound = caseInstance.negotiationRounds.find((round) => round.source.id === entity.id);
			const entityData = deserialize(entity.data);

			if (!negotiationRound) {
				return {
					formId: entity.id,
					formCreatedOn: entity.createdOn,
					decision: entityData?.[AttributeIdentifiers.DecisionTherapy] as CoverageRequestTherapyDecision,
					rating: entityData?.[AttributeIdentifiers.Rating] as CoverageRequestRating,
					startDate: neo4jDateToDate(
						entityData?.[AttributeIdentifiers.TherapyTrialStartDate] || entityData?.[AttributeIdentifiers.CoverageStartDate]
					),
					endDate: neo4jDateToDate(
						entityData?.[AttributeIdentifiers.TherapyTrialEndDate] || entityData?.[AttributeIdentifiers.CoverageEndDate]
					),
				};
			}

			const roundData = deserialize(negotiationRound.data)?.data;
			const decision = (roundData?.[AttributeIdentifiers.DecisionTherapy] ||
				entityData?.[AttributeIdentifiers.DecisionTherapy]) as CoverageRequestTherapyDecision;

			return {
				formId: entity.id,
				formCreatedOn: entity.createdOn,
				decision,
				rating: roundData?.[AttributeIdentifiers.Rating] || (entityData?.[AttributeIdentifiers.Rating] as CoverageRequestRating),
				startDate: neo4jDateToDate(
					roundData?.[AttributeIdentifiers.Timeframe]?.[0] ||
						(decision === CoverageRequestTherapyDecision.Approved
							? entityData?.[AttributeIdentifiers.CoverageStartDate]
							: entityData?.[AttributeIdentifiers.TherapyTrialStartDate])
				),
				endDate: neo4jDateToDate(
					roundData?.[AttributeIdentifiers.Timeframe]?.[1] ||
						(decision === CoverageRequestTherapyDecision.Approved
							? entityData?.[AttributeIdentifiers.CoverageEndDate]
							: entityData?.[AttributeIdentifiers.TherapyTrialEndDate])
				),
			};
		})
		.filter(({ decision }) => decision);
};
